import { THttpService } from '@/services/HttpService';

import { getItems } from '@/helpers/LiferayHelper/liferay';
import { getValue } from '@/helpers/GetValueHelper';

import { TOptinContent, TOptinError } from './types';

const formatSuccess = (data: any) => {
  const items = getItems(data);
  return getValue(items, '[0]', {}) as TOptinContent;
};

export const getContent = async (
  api: THttpService,
  key: string,
): Promise<TOptinContent | TOptinError> => {
  const query = encodeURI(`filter=(title+eq+'${key}')`);
  const path =
    '/o/headless-delivery/v1.0/sites/20124/structured-contents?flatten=true&';

  let data = {};
  try {
    const response = await api.get(path + query);
    data = response.data;
    return formatSuccess(data);
  } catch (error) {
    throw new Error('Error [getContent]');
  }
};
